import * as yup from "yup";

const validation = (messages, { isRia, isProfessional, isOtherPayer }) => {
  return yup.object().shape({
    // signedDirectMandate: yup
    //   .array()
    //   .of(
    //     yup.object().shape({
    //       name: yup.string().required(messages.REQUIRED),
    //     })
    //   )
    //   .required(messages.REQUIRED_ATTACHMENT)
    //   .min(1, messages.REQUIRED_ATTACHMENT)
    //   .max(1, messages.ONE_FILE),
    cin: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),
    socialSecurityCertificate: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),
    paymentAccount: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),
    professionalPaymentAccount:
      isProfessional &&
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE),
    electronicSignatureEligibility:
      isRia &&
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE),
    payerRib:
      isOtherPayer &&
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required(messages.REQUIRED),
          }),
        )
        .required(messages.REQUIRED_ATTACHMENT)
        .min(1, messages.REQUIRED_ATTACHMENT)
        .max(1, messages.ONE_FILE),
  });
};

export default validation;
